import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import Header from "./components/header";
import Home from "./pages/Home/home";
import About from "./pages/About/about";
import Portfolio from "./pages/Portfolio/portfolio";
import Contact from "./pages/Contact/contact";
import WeatherJs from "./pages/Portfolio/projects/weatherJs";
import SketchJs from "./pages/Portfolio/projects/sketchJs";
import RpsJs from "./pages/Portfolio/projects/rpsJs";
import CalculatorJs from "./pages/Portfolio/projects/calculatorJs";
import WeatherReact from "./pages/Portfolio/projects/weatherReact";
import DictionaryReact from "./pages/Portfolio/projects/dictionaryReact";
import BookReact from "./pages/Portfolio/projects/bookReact";
import QuotesGeneratorReact from "./pages/Portfolio/projects/quotesGeneratorReact";
import LoginRegReact from "./pages/Portfolio/projects/loginRegReact";
import ToDoListReact from "./pages/Portfolio/projects/toDoListReact";
import ExpenseTrackerReact from "./pages/Portfolio/projects/expenseTrackerReact";
import ImageGalleryReact from "./pages/Portfolio/projects/imageGalleryReact";
import QuizAppReact from "./pages/Portfolio/projects/quizAppReact";

function App() {
  return (
    <div className="App">
      <Router>
        <Header />

        <Routes>
          <Route path="" element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="portfolio" element={<Portfolio />} />

          <Route path="/weather_js" element={<WeatherJs />} />
          <Route path="/sketch_js" element={<SketchJs />} />
          <Route path="/rps_js" element={<RpsJs />} />
          <Route path="/calculator_js" element={<CalculatorJs />} />
          <Route path="/weather_react" element={<WeatherReact />} />
          <Route path="/dictionary_react" element={<DictionaryReact />} />
          <Route path="/book_react" element={<BookReact />} />
          <Route
            path="/quotes_generator_react"
            element={<QuotesGeneratorReact />}
          />
          <Route
            path="/login_registration_page_react"
            element={<LoginRegReact />}
          />
          <Route path="/to_do_list_react" element={<ToDoListReact />} />
          <Route
            path="/expense_tracker_react"
            element={<ExpenseTrackerReact />}
          />
          <Route path="/image_gallery_react" element={<ImageGalleryReact />} />
          <Route path="/quiz_app_react" element={<QuizAppReact />} />

          <Route path="contact" element={<Contact />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
